// extracted by mini-css-extract-plugin
export var wrap = "Map-module--wrap--1BvMC";
export var link = "Map-module--link--sRvxY";